module.exports = __webpack_public_path__ + "img/mgh-kyobashi-sp@2x.1b1d7bc1.jpg";